package ru.villawonka.app.presentation.screens.settings.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.presentation.design.theme.colorsBackgroundColor1
import ru.villawonka.app.presentation.design.theme.colorsContentEnabled

@Composable
fun SettingsIconView(
    resource: DrawableResource,
    backgroundColor: Color,
) {
    Box(
        modifier = Modifier
            .background(
                color = backgroundColor,
                shape = RoundedCornerShape(8.dp)
            )
            .padding(8.dp)
    ) {
        Icon(
            painter = painterResource(resource),
            contentDescription = null,
            tint = MaterialTheme.colors.colorsContentEnabled
        )
    }
}